import SectionHeading from "./SectionHeading";
import { hotRanking } from "@/mocks/home";

const trendMap: Record<string, { icon: string; className: string }> = {
  up: { icon: "ri-arrow-up-line", className: "text-primary-600" },
  down: { icon: "ri-arrow-down-line", className: "text-secondary-500" },
  flat: { icon: "ri-subtract-line", className: "text-foreground-400" },
};

export default function HotRanking() {
  return (
    <section id="ranking" className="w-full bg-background-50">
      <div className="mx-auto w-full max-w-[1200px] px-4 py-14 md:px-6 md:py-20">
        <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
          <SectionHeading
            index="01"
            eyebrow="Heat Board"
            title="热度榜 · 谁在涨，一眼看清"
            desc="按站内浏览与收藏综合排序，每 2 小时刷新一次热度值。榜单只反映收录内容的关注程度，方便你优先翻看正在升温的图集。"
          />
          <a
            href="#latest"
            className="inline-flex shrink-0 items-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-4 py-2.5 text-sm font-semibold text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700"
          >
            查看完整收录
            <i className="ri-arrow-right-line text-base"></i>
          </a>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-6 lg:grid-cols-3">
          <div className="lg:col-span-2">
            <div className="overflow-hidden rounded-lg border border-background-200 bg-background-50">
              {hotRanking.map((item, index) => {
                const trend = trendMap[item.trend];
                const isTopThree = item.rank <= 3;
                return (
                  <a
                    key={item.rank}
                    href="#latest"
                    className={`flex items-center gap-4 px-4 py-4 transition-colors hover:bg-background-100 md:px-5 ${
                      index !== hotRanking.length - 1 ? "border-b border-background-200" : ""
                    }`}
                  >
                    <span
                      className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-md font-heading text-lg font-bold ${
                        isTopThree ? "bg-accent-500 text-foreground-950" : "bg-background-200 text-foreground-700"
                      }`}
                    >
                      {item.rank}
                    </span>
                    <div className="min-w-0 flex-1">
                      <p className="truncate font-heading text-sm font-semibold text-foreground-950 md:text-base">
                        {item.title}
                      </p>
                      <p className="mt-1 flex items-center gap-2 text-xs text-foreground-500">
                        <span className="truncate">{item.person}</span>
                        <span className="hidden h-3 w-px bg-background-300 sm:block"></span>
                        <span className="hidden whitespace-nowrap rounded-full bg-secondary-100 px-2 py-0.5 text-secondary-800 sm:inline">
                          {item.tag}
                        </span>
                      </p>
                    </div>
                    <div className="flex shrink-0 flex-col items-end gap-1">
                      <span className="font-heading text-sm font-bold text-accent-700 md:text-base">{item.heat}</span>
                      <span className={`flex items-center gap-1 text-[11px] font-medium ${trend.className}`}>
                        <i className={trend.icon}></i>
                        热度
                      </span>
                    </div>
                  </a>
                );
              })}
            </div>
          </div>

          <div className="flex flex-col gap-6">
            <div className="rounded-lg border border-accent-200 bg-accent-50 p-6">
              <div className="flex items-center justify-between">
                <h3 className="font-heading text-base font-bold text-foreground-950">今日飙升榜</h3>
                <span className="flex h-7 w-7 items-center justify-center rounded-md bg-accent-500 text-foreground-950">
                  <i className="ri-fire-line text-base"></i>
                </span>
              </div>
              <ul className="mt-4 flex flex-col gap-3">
                {hotRanking.slice(0, 3).map((item) => (
                  <li key={item.rank} className="flex items-center justify-between gap-3 text-sm">
                    <span className="truncate text-foreground-800">{item.person}</span>
                    <span className="shrink-0 font-semibold text-accent-700">+{item.rank * 7}.{item.rank}%</span>
                  </li>
                ))}
              </ul>
              <p className="mt-4 border-t border-accent-200 pt-3 text-xs leading-relaxed text-accent-900">
                飙升榜反映近 24 小时内新增浏览最快的条目，适合追新。
              </p>
            </div>

            <div className="rounded-lg border border-background-200 bg-background-100 p-6">
              <div className="flex items-center gap-3">
                <span className="flex h-9 w-9 items-center justify-center rounded-md bg-secondary-500 text-background-50">
                  <i className="ri-image-2-line text-lg"></i>
                </span>
                <h3 className="font-heading text-base font-bold text-foreground-950">原图模式已开启</h3>
              </div>
              <p className="mt-3 text-sm leading-relaxed text-foreground-600">
                合集内支持缩略图与原图两种浏览方式，切换后可逐张放大查看高清版本，细节完整保留。
              </p>
              <a
                href="#latest"
                className="mt-4 inline-flex items-center gap-2 whitespace-nowrap text-sm font-semibold text-primary-700 transition-colors hover:text-primary-500"
              >
                进入合集浏览
                <i className="ri-arrow-right-line text-base"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}